(function (window, angular, undefined) {
    angular.module('formApp')
        .directive('anzContactNumberPrepend', [function () {
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function (scope, element, attr, ngModel){
                     ngModel.$setViewValue('07');
                     ngModel.$render();
                    element.bind('click', function() {
                        if(element.prop("selectionStart") <= 3){
                            event.target.setSelectionRange(2,2);
                        }
                    });
                    element.bind("cut copy paste",function(e) {
                        e.preventDefault();
                    });   
                    element.bind('focus', function(){
                        console.log(ngModel.$viewValue.length);
                        element.selectionStart = ngModel.$viewValue.length;
                        ngModel.$render();
                      }); 

                    element.bind("keyup keypress", function (event) {
                        if(event.which === 8 && element.prop("selectionStart") === 1 || event.which === 46 && element.prop("selectionStart") === 1) {
                            ngModel.$setViewValue('07');
                            ngModel.$render();
                            element.selectionStart = 3;
                            
                        }
                        if(event.which === 8 && element.prop("selectionStart") === 0 || event.which === 46 && element.prop("selectionStart") === 0 ) {
                            ngModel.$setViewValue('07');
                            ngModel.$render();
                            element.selectionStart = 3;
                            
                        }
                    });
                }
            };
        }]);
})(window, window.angular);